import React, { useContext } from "react";
import { Box } from "@mui/material";
import VirtualRegistrationSettings from "components/vaccine/queue/VirtualRegistrationSettings";
import TextSequence from "components/vaccine/TextSequence";
import PremiumWrapper from "components/dashboard/PremiumWrapper";
import { AuthContext } from "context/Auth";

const VirtualRegistrationPage = ({ data, setData }) => {
  const { subscription } = useContext(AuthContext);

  return (
    <Box>
      <VirtualRegistrationSettings data={data} setData={setData} />

      <PremiumWrapper disabled={!subscription}>
        <TextSequence data={data} setData={setData} />
      </PremiumWrapper>
    </Box>
  );
};

export default VirtualRegistrationPage;
